import {
  Button,
  ButtonsWrapper,
  CheckboxInput,
  Form,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { ProjectStatusesEnum } from '@thinknet-gmbh/platform-common';
import { useTranslation } from 'react-i18next';

import { FilterWrapper } from './project-table-filter.styles';

const ProjectTableFilter = ({
  onFinish,
  onCancel,
  projectStatuses,
}: {
  onFinish: (values: any) => void;
  onCancel: () => void;
  projectStatuses: ProjectStatusesEnum[];
}) => {
  const { t } = useTranslation(['common', 'projects']);

  return (
    <FilterWrapper>
      <Typography weight="bold">{t('projects:labels.projectType')}</Typography>
      <Form layout="vertical" onFinish={onFinish}>
        {Object.keys(ProjectStatusesEnum).map(key => {
          const isChecked = projectStatuses.find(item => item === key);

          return (
            <Form.Item
              key={key}
              name={key}
              valuePropName="checked"
              initialValue={Boolean(isChecked)}
            >
              <CheckboxInput value={key}>{key.toLowerCase()}</CheckboxInput>
            </Form.Item>
          );
        })}
        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.apply')}
          </Button>
          <Button onClick={onCancel}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </FilterWrapper>
  );
};

export default ProjectTableFilter;
